import { createContext, useContext, useEffect, useState } from "react";
import { COPY } from "@/content";

const LanguageContext = createContext({ lang: "de", setLang: () => {}, copy: COPY.de });

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => window.localStorage.getItem("cb-lang") || "en");

  useEffect(() => {
    window.localStorage.setItem("cb-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, copy: COPY[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
